import type * as React from "react"

/** True on macOS / iOS, where the primary modifier is ⌘ instead of Ctrl. */
export const isMac =
  typeof navigator !== "undefined" && /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent)

/** Whether a keyboard event carries the platform's primary modifier (⌘ or Ctrl). */
export function hasModKey(e: KeyboardEvent | React.KeyboardEvent) {
  return isMac ? e.metaKey : e.ctrlKey
}

/** True when focus is in a text field, where single-key shortcuts must not fire. */
export function isTypingTarget(target: EventTarget | null) {
  if (!(target instanceof HTMLElement)) return false
  if (target.isContentEditable) return true
  const tag = target.tagName
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT"
}
